import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import MoreInfoSection from '@/sections/MoreInfo';
import { LINKS } from '@/constants/links';
import { AnimatedContent } from '@/components/animation';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
function MoreInfo() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["homepage", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isCsLanguage || $[3] !== t) {
    t2 = <AnimatedContent className="relative overflow-hidden">{t1}<MoreInfoSection className="relative z-10" buttons={isCsLanguage ? [{
        analyticsParam: "homepageMoreInfoDeferredPayment",
        icon: <IconDeferredPayment className="fillButtonIcon" />,
        testId: "homepageMoreInfoDeferredPayment",
        title: t("core:products.deferredPayment"),
        to: LINKS().deferredPayment
      }, {
        analyticsParam: "homepageMoreInfoRevolvingApplication",
        icon: <IconMaxi className="fillButtonIcon" />,
        testId: "homepageMoreInfoRevolvingApplication",
        title: t("core:products.revolving"),
        to: LINKS().revolving
      }, {
        analyticsParam: "homepageMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "homepageMoreInfoPayInThree",
        title: t("core:products.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "homepageMoreInfoCard",
        icon: <IconCard className="fillButtonIcon" />,
        testId: "homepageMoreInfoCard",
        title: t("core:products.card"),
        to: LINKS().card
      }] : [{
        analyticsParam: "homepageMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "homepageMoreInfoPayInThree",
        title: t("core:products.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "homepageMoreInfoWhereToShop",
        icon: <IconShoppingCart className="fillButtonIcon" />,
        testId: "homepageMoreInfoWhereToShop",
        title: t("core:products.whereToShop"),
        to: LINKS().whereToShop
      }, {
        analyticsParam: "homepageMobileApp",
        icon: <IconMobile className="fillButtonIcon" />,
        testId: "homepageMoreInfoMobileApp",
        title: t("core:products.mobileApp"),
        to: LINKS().mobileApp
      }, {
        analyticsParam: "homepageMoreInfoAboutCompany",
        icon: <IconUser className="fillButtonIcon" />,
        testId: "homepageMoreInfoAboutCompany",
        title: t("core:link.aboutUs"),
        to: LINKS().aboutCompany
      }]} /></AnimatedContent>;
    $[2] = isCsLanguage;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export default MoreInfo;